export default {
  system: {
    systemName: '网上服务',
    logOut: '注销',
    profile: '简介'
  },
  route: {
    mdCodeTypeDefaultManage: '数据字典',
    staffManagement: '内部用户管理',
    InvoiceQuery: '发票查询',
    sysRoleManage: '用户角色',
    HistoryEdit: '修改历史查询',
    BillDetail: '账单明细',
    orderInvoiceDetails: '订单发票明细',
    overseasWelcome: '海外欢迎',
    ILPWMS: '分拨主单查询',
    dashboard: '首页',
    documentation: '文档',
    guide: '引导页',
    permission: '系统权限',
    rolePermission: '角色权限',
    pagePermission: '页面权限',
    directivePermission: '指令权限',
    icons: '图标',
    components: '组件',
    tinymce: '富文本编辑器',
    markdown: 'Markdown',
    jsonEditor: 'JSON 编辑器',
    dndList: '列表拖拽',
    splitPane: 'Splitpane',
    avatarUpload: '头像上传',
    dropzone: 'Dropzone',
    sticky: 'Sticky',
    countTo: 'Count To',
    componentMixin: '小组件',
    backToTop: '返回顶部',
    dragDialog: '拖拽 Dialog',
    dragSelect: '拖拽 Select',
    dragKanban: '可拖拽看板',
    charts: '图表',
    keyboardChart: '键盘图表',
    lineChart: '折线图',
    mixChart: '混合图表',
    example: '综合实例',
    Table: 'Table',
    dynamicTable: '动态 Table',
    dragTable: '拖拽 Table',
    inlineEditTable: 'Table 内编辑',
    complexTable: '表格',
    componentTable: '组件-表格',
    form: '表单',
    createArticle: '创建文章',
    editArticle: '编辑文章',
    articleList: '文章列表',
    errorPages: '错误页面',
    page401: '401',
    page404: '404',
    errorLog: '系统日志',
    excel: 'Excel',
    exportExcel: '导出 Excel',
    selectExcel: '导出 已选择项',
    mergeHeader: '导出 多级表头',
    uploadExcel: '上传 Excel',
    zip: 'Zip',
    pdf: 'PDF',
    exportZip: 'Export Zip',
    theme: '换肤',
    clipboardDemo: 'Clipboard',
    i18n: '国际化',
    ediSetting: 'EDI设置',
    ediApp: '应用接入配置',
    ediType: 'EDI报文类型',
    ediCodeType: 'EDI代码类型',
    ediInteraction: 'EDI交互方',
    codeConversion: 'EDI代码转换',
    demo: '例子',
    messageDefinition: 'EDI报文定义',
    referenceConfiguration: 'EDI引用配置',
    configTransform: 'EDI代码对照表',
    configAuth: 'EDI代配置授权',
    downloadSetting: '模板下载授权',
    queryEDI: 'EDI查询',
    searchTrack: 'EDI状态跟踪',
    searchReceipt: 'EDI回执查询',
    searchException: 'EDI异常情况查询',
    searchLog: 'EDI操作日志查询',
    monitor: 'EDI监控',
    monitorImport: 'EDI导入监控',
    monitorExport: 'EDI导出监控',
    alarm: 'EDI告警',
    alarmRule: '告警规则配置',
    alarmEvent: '告警事件列表',
    alarmResult: '告警处理结果',
    messageManage: '消息管理',
    booking: '订单管理',
    bookingAdd: '订单新增',
    bookingEdit: '订单编辑',
    bookingEdi: 'EDI订单',
    bookingManage: '订单管理',
    bookingTemplateManagement: '订单模板管理',
    VGMAdd: 'VGM 新增',
    VGMManage: 'VGM 管理',
    VGMEdit: 'VGM 编辑',
    manifest: '预配舱单管理',
    appointment: '预约',
    AppointmentCheck: '预约查验',
    AdvanceDelivery: '预约提货',
    manifestManagement: '预配舱单管理',
    manifestAdd: '预配舱单新增',
    manifestEdi: '预配舱单编辑',
    ladingbill: '提单确认管理',
    ladingbillManagement: '提单确认管理',
    ladingbillEdi: 'EDI提单确认',
    ladingbillEdit: '提单确认编辑',
    onlineOrderMatching: '提单在线对单',
    vipplatform: 'VIP客户平台',
    huaweiplatform: '华为',
    overseasagency: '海外代理',
    DsrQuery: 'DSR查询',
    BoxInformationQuery: '箱货信息查询',
    query: '综合查询',
    Invoice: '发票查询',
    InvoiceDetail: '发票详情',
    ShippingDate: '船期查询',
    StatusHistory: '状态历史查询',
    Bill: '账单查询',
    ShipSchedule: '船期查询',
    ServiceConsultation: '服务咨询',
    MessageSubscription: '消息订阅',
    system: '系统管理',
    PreRecordedCustoms: '报关预录单查询',
    OpenOnlineService: '开启网上服务',
    Maintenance: '系统功能维护',
    UserManagement: '用户管理',
    PermissionConfiguration: '权限配置',
    UserMaintain: '用户维护',
    UserEdit: '用户编辑'
  },
  navbar: {
    dashboard: '首页',
    switch: '切换角色',
    logOut: '退出登录',
    changePassword: '修改密码',
    theme: '换肤',
    size: '布局大小',
    refresh: '刷新',
    fullscreen: '是否全屏',
    langSelect: '语言切换',
    zh: '中文',
    en: 'English',
    message: '消息中心',
    messageDetail: '条未读消息'
  },
  login: {
    home: '首页',
    forgetpassword: '忘记密码',
    rememberPassword:"记住密码",
    register: '货主用户注册',
    title: '系统登录',
    logIn: '登录',
    username: '账号',
    password: '密码',
    any: '随便填',
    thirdparty: '第三方登录',
    thirdpartyTips: '本地不能模拟，请结合自己业务进行模拟！！！'
  },
  home: {
    serviceInformation: '服务指南',
    booking: '我要订舱',
    bookingQuery : '订舱查询',
    adminLogin: '管理员登录',
    login: '登录',
    title:'在线服务平台',
    ctsCr: '港中旅华贸国际物流股份有限公司',
    dvCr: '上海德祥国际货运代理有限公司',
    glCr:'技术支持：上海吉联新软件股份有限公司',
    cargoTracking:"箱货跟踪",
    customerServiceTel: '客服热线:4001-223-591',
  },
  permission: {
    addRole: '新增角色',
    editPermission: '编辑权限',
    roles: '你的权限',
    switchRoles: '切换权限',
    tips: '在某些情况下，不适合使用 v-permission。例如：Element-UI 的 el-tab 或 el-table-column 以及其它动态渲染 dom 的场景。你只能通过手动设置 v-if 来实现。',
    delete: '删除',
    confirm: '确定',
    cancel: '取消'
  },
  tagsView: {
    refresh: '刷新',
    close: '关闭',
    closeOthers: '关闭其它',
    closeAll: '关闭所有'
  },
  settings: {
    title: '系统布局配置',
    theme: '主题色',
    tagsView: '开启 Tags-View',
    fixedHeader: '固定 Header',
    sidebarLogo: '侧边栏 Logo'
  },
  button: {
    addARole: '添加角色',
    removeARole: '移除角色',
    resetPassword: '重置密码',
    addUser: '新增用户',
    deleteUser: '删除用户',
    takeEffect: '生效',
    loseEfficacy: '失效',
    signIn: '登录',
    startSearching: '开始搜索',
    query: '查询',
    querying: '查询中',
    reset: '重置',
    add: '新增',
    batchSave: '批量保存',
    batchSaving: '批量保存中',
    batchDelete: '批量删除',
    delete: '删除',
    pause: '暂停',
    start: '启用',
    starting: '启用中',
    save: '保存',
    saving: '保存中',
    submit: '提交',
    submitting: '提交中',
    submitReview: '提交审核',
    submitReviewing: '提交审核中',
    copy: '复制',
    confirm: '确认',
    close: '关闭',
    preview: '预览'
  },
  // 多个界面共有
  table: {
    userRole: '用户角色',
    customerName: '客户名称',
    entryTime: '入职时间',
    validMark: '有效标志',
    dataScope: '数据权限范围',
    orderSource: '订单来源',
    loginAccount: '登录账号',
    chineseName: '中文名称',
    englishName: '英文名称',
    eMailAddress: '电子邮箱',
    telephoneNumber: '手机号码',
    dataPermission: '数据权限',
    effective: '是否有效',
    roleName: '角色名称',
    OwningRegion: '所属区域',
    affiliatedCompany: '所属公司',
    valid: '有效',
    effectiveTime: '生效时间',
    failureTime: '失效时间',
    sex: '性别',
    mobilePhone: '手机号',
    officeTelephone: '办公电话',
    fax: '传真',
    qqNumber: 'QQ号',
    wechatNumber: '微信号',
    identityCardNo: '身份证号码',

    remark: '备注',
    creatorName: '创建人',
    createTime: '创建时间',
    lastModifierName: '最后修改人',
    lastModifyTime: '最后修改时间',
    settleOfficeName: '结算公司',
    settleOfficeCode: '结算公司编号',
    redStar: '<label style=\'color:red\'>*</label>',
    select: '请选择',
    to: '至',
    startTime: '开始日期',
    endTime: '结束日期',
    theRecentWeek: '最近一周',
    theRecentMonth: '最近一个月',
    theRecentThreeMonths: '最近三个月',
    today: '今天',
    yesterday: '昨天',
    aWeekAgo: '一周前',
    saleCode: '销售代码',
    saleName: '销售名称',
    salePersonCode: '销售HR代码',
    salePersonName: '销售HR名称',
    inoperable: '不可操作',
    custCode: '客商编码',
    custName: '客商名称',
    custShortName: '客商简称',
    rememberNo: '助记码',
    audited: '已审核',
    notAudited: '未审核',
    code: '单位代码',
    name: '单位名称',
    templateCode: '模版代码',
    templateName: '模版名称',
    taxRate: '税率',
    codeValue: '字段编码',
    displayValueCn: '字段中文',
    displayValueEN: '字段英文',
    fileName: '文件名称',
    selectTime: '选择日期',
    pleaseSelect: '请选择',
    pleaseEnterEnglish: '请输入英语',
    pleaseEnter: '请输入',
    noInformation: '暂无船公司扩展信息'
  },
  // 校验
  rule: {
    notNull: '不能为空',
    richLength20: '长度不能超过20',
    richLength50: '长度不能超过50',
    maxNotLessThanMin: '最大值不能小于最小值',
    EnglishAndNumbers: '只能输入英文及数字'
  },
  // 提示信息
  message: {
    PleaseCheckARecord: '请勾选一条记录',
    effectiveSuccess: '生效成功',
    cannotTakeEffectAgain: '该用户已是生效用户，不可再生效',
    failureSuccess: '失效成功',
    cannotTakeInvalidAgain: '该用户已是失效用户，不可再失效',
    enterTheRequiredFields: '请输入必填项',
    saveTheUserFirst: '请先保存用户！',
    selectOneRecordToDelete: '请至少选择一条记录进行删除!',
    selectOneRecordToTakeEffect: '请至少选择一条记录进行生效!',
    selectOneRecordToLoseEfficacy: '请至少选择一条记录进行失效!',
    HaveComeIntoEffect: '已生效',
    Expired: '已失效',
    selectAnInactiveRecord: '请选择未生效的记录!',
    selectAnInUnexpiredRecord: '请选择未失效的记录!',
    cannotBeDeleted: '存在未失效的用户,不可删除!',

    location: '获取定位失败!',
    noUnsavedData: '不存在未保存的数据',
    batchSaveFailed: '批量保存失败',
    batchSaveSuccessful: '批量保存成功',
    batchDeleteFailed: '批量删除失败',
    batchDeleteSuccessful: '批量删除成功',
    saveFailed: '保存失败',
    saveSuccessful: '保存成功',
    deleteFailed: '删除失败',
    deleteSuccessful: '删除成功',
    sureDelete: '是否确认删除?',
    checkDataDeleted: '请勾选需要删除的数据',
    checkDataPaused: '请勾选需要暂停的数据',
    checkDataEnabled: '请勾选需要启用的数据',
    warning: '警告',
    success: '成功',
    error: '错误',
    info: '消息',
    confirm: '确定',
    yes: '是',
    no: '否',
    UnsavedData: '存在未保存的记录，请先保存!',
    selectTypeTableData: '请选择类型表数据',
    NoNewOrModifiedData: '没有新增或修改的数据',
    formVerificationFailed: '表单校验不通过!',
    unableToDeleteQuotation: '报价单已提交或已审核，无法删除！',
    notNeedPausedQuotation: '勾选的数据中存在已暂停的报价!',
    notNeedEnabledQuotation: '勾选的数据中存在已启用的报价!',
    selectedQuotationNotBeenAudited: '选中的报价单存在未审批的报价单!',
    pauseSuccessful: '暂停成功',
    pauseFailed: '暂停失败',
    surePauseQuotation: '是否确认暂停报价单?',
    sureEnableQuotation: '是否确认启用报价单?',
    enabledSuccessful: '启用成功',
    enabledFailed: '启用失败',
    getDataFailed: '获取数据失败:',
    currentPageNotSaved: '当前页面未保存，是否继续查询?',
    tips: '提示',
    querying: '查询中',
    saving: '保存中',
    checkDataCopy: '请勾选要复制的数据',
    onlyOneCheck: '只能勾选一条数据进行复制',
    beforeAdding: '请进行查询选中数据后新增',
    notDeleteEnable: '存在已启用的记录，不允许删除',
    checkEnableOrPause: '请选择要启用或者停用的数据',
    operateSuccessful: '操作成功',
    operateFailed: '操作失败',
    sizeCannotExceed: '上传文件大小不能超过 1MB!',
    notMeetRequirements: '上传文件的类型不符合要求',
    duplicateIconName: '图标名称重复,无法上传!',
    uploadSuccessful: '上传成功！',
    ErrorIconAddress: '获取图标地址错误',
    checkOneData: '至少勾选一条数据',
    notSavedContinueAdding: '当前页面未保存，是否继续新增?',
    notSavedContinueClose: '当前页面未保存，是否继续关闭?',
    selectPrint: '请选择一笔需要打印的套版',
    contactAdministrator: '无法删除，请联系系统管理员',
    calledNotModify: '已被调用，无法修改!',
    productTypeNotModified: '产品类型不可修改',
    selectAgreementData: '请选择协议表数据',
    selectFeeData: '请选择费用表数据',
    feeNamesMustUnique: '同一条协议下的费用名称必须唯一!',
    elementsMustUnique: '同一条协议下同一条费用的业务要素必须唯一',
    typeCalledNotModify: '协议类型已被调用，无法修改!',
    calledNotDelete: '已被调用，无法删除!',
    querySucceeded: '查询成功！',
    noMerchantFound: '未找到客商',
    submittedSuccessfully: '提交成功！',
    submissionFailure: '提交失败！',
    undoSubmissionSuccessful: '撤销提交成功',
    failedToUndoCommit: '撤销提交失败',
    whetherToDelete: '是否删除勾选数据？',
    whetherToCancel: '是否执行撤销操作？',
    unableToExport: '未进行查询无法导出！',
    checkSingleRecord: '请勾选单条记录',
    pleaseCheckRecord: '请勾选记录',
    cannotBeEmpty: '查询条件不能为空',
    noDataExists: '没有数据，请重新输入查询条件！',
    selectAData: '请勾选一条数据！',
    pleaseCheck: "报表路径错误，请检查！",
    pleaseSelectData: '请选择数据！',
  },
  messageSetting: {
    messageType: '报文类型',
    messageName: '报文名称',
    ediSort: 'EDI 分类',
    serviceAddress: '服务地址',
    interactiveCompany: '交互公司',
    interactiveMode: '交互方式',
    interactiveAddressParameters: '交互地址参数',
    messageStandard: '报文标准',
    application: '所属应用',
    transcodingConfiguration: '代码转换配置',
    companyReferenceConfiguration: '公司引用配置',
    importAndExportConfiguration: '导入导出配置',
    codeType: '代码类型',
    codeName: '代码名称',
    creator: '创建人',
    creationTime: '创建时间',
    reviser: '修改人',
    modificationTime: '修改时间',
    fieldCode: '字段代码',
    fieldName: '字段名称',
    fieldValue: '字段值',
    branchCode: '分公司代码',
    branchName: '分公司名称',
    department: '部门'
  },
  ediType: {
    typeCode: '类型代码',
    typeName: '类型名称',
    EDIClass: 'EDI分组',
    creator: '创建人',
    creatTime: '创建时间',
    creatorName: '创建人',
    createTime: '创建时间',
    lastModifierName: '修改人',
    lastModifyTime: '修改时间'
  },
  ediCodeType: {
    codeType: '代码类型',
    codeName: '代码名称',
    codeTypeName: '代码类型名称',
    creatorName: '创建人',
    createTime: '创建时间',
    lastModifierName: '修改人',
    lastModifyTime: '修改时间'
  },
  ediApp: {
    appCode: '应用代码',
    appName: '应用名称',
    appSign: '应用标识',
    creatorName: '创建人',
    createTime: '创建时间',
    lastModifierName: '修改人',
    lastModifyTime: '修改时间'
  },
  ediInteraction: {
    ediInteractionCode: '交互方代码',
    ediInteractionName: '交互方名称',
    registerCode: '交互方注册代码',
    registerName: '交互方注册名称',
    creatorName: '创建人',
    createTime: '创建时间',
    importEmail: '导入邮箱',
    exportEmail: '导出邮箱',
    importURL: '导入路径',
    exportURL: '导出路径',
    FTPHost: 'FTP主机',
    FTPPort: 'FTP端口',
    FTPUserName: 'FTP用户名',
    FTPassword: 'FTP密码'
  },
  messageDefinition: {
    messageType: '报文类型',
    EDIGrouping: 'EDI分组',
    serviceAddress: '服务地址',
    messageFormat: '报文格式',
    interactiveCompany: '交互公司',
    commonCodeConversionSystem: '公共代码转换体系',
    interactiveMode: '交互方式',
    autoSend: '自动发送',
    messageName: '报文名称',
    ediInteraction: '交互方',
    ediInteractionCode: '交互方代码',
    ediInteractionName: '交互方名称',
    ediInteractionRegisterCode: '交互方注册代码',
    ediInteractionRegisterName: '交互方注册名称',
    sender: '发送方',
    receiver: '接收方'
  },
  ReferenceConfiguration: {
    addReference: '添加引用',
    branchRegistrationCode: '分公司注册代码',
    branchRegistrationName: '分公司注册名称',
    departmentCode: '部门代码',
    branchDescription: '分公司描述'
  },
  codeConversion: {
    codeType: '代码类型',
    codeTypeName: '代码类型名称',
    conversionRules: '转换规则',
    defaultCode: '默认代码',
    internalCode: '内部代码',
    internalName: '内部名称',
    externalCode: '外部代码',
    externalName: '外部名称'
  },
  //文件上传
  fileUpload: {
    Drag: '拖拽此处,或',
    clickToUpload: '点击上传',
    format: '格式:word,excel,pdf,jpg,png不超过10MB.',
    formatCd: '格式:word,excel,pdf,jpg,png不超过4MB.',
    formatWm: '只能上传xlsx、xls文件，且不超过10MB',
    fileName: '文件名',
    documentTypeCode: '文件类型',
    chooseDocumentTypeCode: '请选择',
    uploadStatus: '上传状态',
    importStatus: '导入状态',
    uploading: '上传中...',
    uploaded: '已上传!',
    uploadFailed: '上传失败!',
    fileStatus: '归档状态',
    operation: '操作',
    download: '下载',
    delete: '删除',
  },
  searchData: {
    invoiceSerialNo: '提单号',
    invoiceNo: '发票号码',
    onceInvoiceNo: '账单流水号',
    issuedDateFrom: '开票日期从',
    issuedDateTo: '开票日期到',
    invoiceType: '发票类型',
    invoiceTypeMessage: '请选择发票类型',

  },
  bcInvoice: {
    invoiceSerialNo: '提单号',
    invoiceNo: '发票号码',
    invoiceCode: '发票代码',
    issuedDate: '开票日期',
    invoiceType: '发票类型',
    settleCustName: '结算对象',
    taxpayerIdentificatioNo: '纳税人识别号',
    invoiceAmount: '合计'
  },
  /* 联想控件 */
  associate: {
    permissionName: '权限名称',
    custAlias: "客商简称",
    consignorName: "客商全称",
    mnemonicCode: "助记码",
    vesselName: "船名",
    voyage: "航次",
    voyageCode: "航次代码",
    portNameEn: '英文名称',
    portNameCn: "中文名称",
    countryCode: "国家代码",
    portCode: "海港代码",
    typeOfService: "业务类型",
    codeValue: "业务类型代码",
    code: '代码',
    fullCN: '中文全称',
    fullEN: '英文全称',
    userCode: '用户编码',
    boxTypeSize: '箱型尺寸'
  }
}
